import {DigitalRevisionMenuItem} from '../../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../../interfaces/menu-item-type-enum';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: 'quick-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/_TEST/TRHP20/quick-quiz',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      'Test yourself on all the required vocab and grammar. On your marks, get set... quiz!\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'TRHP20 QQ',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/_TEST/TRHP20/mistakes',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here &mdash; have another go and conquer them once and for all!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'TRHP20 Mistakes',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/_TEST/TRHP20/revision-summary-test',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'TRHP20 RST',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.ExamPracticeQuestions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Exam Practice Questions',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/_TEST/TRHP20/digital-workbook',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Exam Practice Questions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'All the questions from your book',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.QuotationFlashcards,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Flashcards',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/_TEST/TRHP20/flashcards',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: false,
    HeadingText: 'Flashcards',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Key quotes on the front and helpful analysis on the back.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Speedy on-the-go revision',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      IntroTitle: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Timeline,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Timeline',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/_TEST/TRHP20/timeline',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: false,
    HeadingText: 'Timelines',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>All the key events for this topic laid out for you. Expand them to see more detail — super handy!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Test_Timelines',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Summary Test',
        ImagePath: '/assets/images/landing/revision-summary-test.png',
        DestinationPage: 'Revision-Summary-Test',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      IntroTitle: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];
